module.exports = __webpack_public_path__ + "img/orange_square_desktop.bf8b911f.png";